import React from 'react'
import {Card, CardBody, Col, FormGroup, Input, Nav,} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../Alerts/ErrorModal";
import businessHelper from "../../helpers/BusinessHelper";
import reportApiService from "../../api/report-api-service";
import Cashiers from "./Cashiers";
import CashierIncomesTable from "./CashierIncomesTable";
import CardTitle from "reactstrap/es/CardTitle";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const propTypes = {};

export default class CashierView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            monthShift: 0,
            cashierData: null,
            currentCashier: {},
            cashIncValue: 0,
            cashExpValue: 0,
            cardIncValue: 0,
            cardExpValue: 0,
            bankIncValue: 0,
            bankExpValue: 0,
            tablesUpdatedTimes: 0,
            dateValue: dateHelpers.databaseDate(new Date()),
            editing: false,
            currency: businessHelper.currency(),
            incomesExpenses: {tickets: [], incomes: [], expenses: []},
            addedTransactions: [],
        };
    }

    onCashierDelete = this.onCashierDelete.bind(this);
    onCashierEdit = this.onCashierEdit.bind(this);
    cancelEditing = this.cancelEditing.bind(this);
    updateCashier = this.updateCashier.bind(this);
    addIncomingTransaction = this.addIncomingTransaction.bind(this);
    removeIncomingTransaction = this.removeIncomingTransaction.bind(this);

    addOutcomingTransaction = this.addOutcomingTransaction.bind(this);
    removeOutcomingTransaction = this.removeOutcomingTransaction.bind(this);

    componentDidMount() {
        this.getData()
        this.getIncomesExpenses()
        localStorage.cashier_month_shift = 0
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.monthShift != this.state.monthShift) {
            this.getData()
        }

        if (prevState.dateValue != this.state.dateValue) {
            this.getIncomesExpenses()
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleChange(event) {
        let newValue = event.target.value;
        let newValueRaw = event.target.value;
        let targetId = event.target.id;

        if (targetId != "input-date") {
            newValue = formatNumber(newValue)
        }

        switch (targetId) {
            case "input-date":
                this.setState(prevState => ({
                    currentCashier: {
                        ...prevState.currentCashier,
                        date: newValue
                    },
                    dateValue: newValueRaw
                }));
                break;
            case "input-cash-inc":
                this.setState(prevState => ({
                    currentCashier: {
                        ...prevState.currentCashier,
                        cash_income: newValue
                    },
                    cashIncValue: newValueRaw
                }));
                break;
            case "input-card-inc":
                this.setState(prevState => ({
                    currentCashier: {
                        ...prevState.currentCashier,
                        card_income: newValue
                    },
                    cardIncValue: newValueRaw
                }));
                break;
            case "input-bank-inc":
                this.setState(prevState => ({
                    currentCashier: {
                        ...prevState.currentCashier,
                        bank_income: newValue
                    },
                    bankIncValue: newValueRaw
                }));
                break;

            case "input-cash-exp":
                this.setState(prevState => ({
                    currentCashier: {
                        ...prevState.currentCashier,
                        cash_expense: newValue
                    },
                    cashExpValue: newValueRaw
                }));
                break;
            case "input-card-exp":
                this.setState(prevState => ({
                    currentCashier: {
                        ...prevState.currentCashier,
                        card_expense: newValue
                    },
                    cardExpValue: newValueRaw
                }));
                break;
            case "input-bank-exp":
                this.setState(prevState => ({
                    currentCashier: {
                        ...prevState.currentCashier,
                        bank_expense: newValue
                    },
                    bankExpValue: newValueRaw
                }));
                break;
            default:
                return null;
        }

        function formatNumber(value) {
            const v = parseFloat(value) * 100
            return v
        }
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Col lg="12">
                        <Card className="bg-default shadow">
                            <Row className="ml-4">
                                <h2 className="text-warning mb-0">{this.reportName()}</h2>
                            </Row>
                            <div className="ml-4">
                                <small className="text-white">{reportStrings.cashier_expl}</small>
                            </div>

                            {this.state.currentCashier &&
                            <Row style={{marginLeft: "2rem", marginTop: "2rem", marginRight: "2rem"}}>
                                <Col lg="8">
                                    <label
                                        className="form-control-label text-white text-lg"
                                    >
                                        {reportStrings.start_total}
                                    </label>
                                    <label
                                        className="form-control-label text-white ml-1 text-lg"
                                    >
                                        {this.state.currency + this.state.currentCashier.start_total}
                                    </label>

                                    <div>
                                        <label
                                            className="form-control-label text-warning text-sm"
                                        >
                                            {reportStrings.cash_start_total}
                                        </label>
                                        <label
                                            className="form-control-label text-warning ml-1 text-sm"
                                        >
                                            {this.state.currency + this.state.currentCashier.start_cash_total}
                                        </label>
                                    </div>

                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-date"
                                        >
                                            {commonStrings.date}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.dateValue}
                                            id="input-date"
                                            type="date"
                                        />

                                    </FormGroup>

                                    <hr style={{backgroundColor: "gray"}}/>

                                    <Row>
                                        <label
                                            className="form-control-label text-white"
                                        >
                                            {reportStrings.day_incomes}:
                                        </label>
                                        <label
                                            className="form-control-label text-white ml-1"
                                        >
                                            {this.dayIncomeTotal()}
                                        </label>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-cash-inc"
                                                >
                                                    {resourceStrings.payment_methods.cash + ` (${this.state.currency})`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={this.state.cashIncValue}
                                                    id="input-cash-inc"
                                                    type="number"
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-card-inc"
                                                >
                                                    {resourceStrings.payment_methods.cc + ` (${this.state.currency})`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={this.state.cardIncValue}
                                                    id="input-card-inc"
                                                    type="number"
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />

                                            </FormGroup>
                                        </Col>

                                        <Col>
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-bank-inc"
                                                >
                                                    {resourceStrings.payment_methods.bank + ` (${this.state.currency})`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={this.state.bankIncValue}
                                                    id="input-bank-inc"
                                                    type="number"
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />

                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <hr style={{backgroundColor: "gray"}}/>

                                    <Row>
                                        <label
                                            className="form-control-label text-white"
                                        >
                                            {reportStrings.day_expenses}:
                                        </label>
                                        <label
                                            className="form-control-label text-white ml-1"
                                        >
                                            {this.dayExpenseTotal()}
                                        </label>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-cash-exp"
                                                >
                                                    {resourceStrings.payment_methods.cash + ` (${this.state.currency})`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={this.state.cashExpValue}
                                                    id="input-cash-exp"
                                                    type="number"
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />

                                            </FormGroup>
                                        </Col>

                                        <Col>
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-card-exp"
                                                >
                                                    {resourceStrings.payment_methods.cc + ` (${this.state.currency})`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={this.state.cardExpValue}
                                                    id="input-card-exp"
                                                    type="number"
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />

                                            </FormGroup>
                                        </Col>

                                        <Col>
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-bank-exp"
                                                >
                                                    {resourceStrings.payment_methods.bank + ` (${this.state.currency})`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={this.state.bankExpValue}
                                                    id="input-bank-exp"
                                                    type="number"
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />

                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="text-right">
                                        <label
                                            className="form-control-label text-white text-lg"
                                        >
                                            {reportStrings.day_total}
                                        </label>
                                        <label
                                            className="form-control-label text-white ml-1 text-lg"
                                        >
                                            {this.state.currency + this.state.currentCashier.total}
                                        </label>

                                        <div className="text-right">
                                            <label
                                                className="form-control-label text-warning text-sm"
                                            >
                                                {reportStrings.cash_day_total}
                                            </label>
                                            <label
                                                className="form-control-label text-warning ml-1 text-sm"
                                            >
                                                {this.state.currency + this.state.currentCashier.cash_total}
                                            </label>
                                        </div>

                                        <br/>
                                        {this.state.editing ?
                                            (<div className="mb-2">
                                                <Button
                                                    color="secondary"
                                                    onClick={e => this.cancelEditing(e)}
                                                >
                                                    {commonStrings.cancel}
                                                </Button>

                                                <Button
                                                    color="success"
                                                    onClick={e => this.updateCashier(e)}
                                                >
                                                    {commonStrings.save}
                                                </Button>
                                            </div>)
                                            :
                                            (<Button className="mb-2"
                                                     color="success"
                                                     onClick={e => this.closeDay(e)}
                                            >
                                                {reportStrings.close_day}
                                            </Button>)
                                        }
                                    </div>

                                    <hr style={{backgroundColor: "gray"}}/>
                                </Col>

                                <p style={{marginTop: "2rem"}}>
                                    <small className="text-white">{reportStrings.cashier_inc_exp_expl}</small>
                                </p>
                                <Card className="bg-default shadow" style={{width: "100%"}}>
                                    <CardBody>
                                        <CardTitle
                                            tag="h5"
                                            className="text-uppercase text-green mb-0"
                                        >
                                            {dateHelpers.formatDate(new Date(this.state.dateValue))} | {reportStrings.day_incomes}
                                        </CardTitle>

                                        <Row className="mt-4" style={{width: "100%"}}>
                                            {this.renderIncomesReport()}
                                        </Row>
                                    </CardBody>
                                </Card>

                                <Card className="bg-transparent shadow" style={{width: "100%"}}>
                                    <CardBody>
                                        <CardTitle
                                            tag="h5"
                                            className="text-uppercase text-green mb-0"
                                        >
                                            {dateHelpers.formatDate(new Date(this.state.dateValue))} | {reportStrings.day_expenses}
                                        </CardTitle>
                                        <Row className="mt-4" style={{width: "100%"}}>
                                            {this.renderExpenseReport()}
                                        </Row>
                                    </CardBody>
                                </Card>

                                <Card className="bg-default shadow mt-6" style={{width: "100%"}}>
                                    <Row style={{width: "100%"}}>
                                        <div className="col mr-3 mb-4 mt--4" style={{width: "100%"}}>
                                            <Nav className="justify-content-center" pills>
                                                <Button
                                                    color="secondary"
                                                    href="#pablo"
                                                    onClick={e => this.nextMonth(e, -1)}
                                                    size="sm"
                                                >
                                                    <span className="d-none d-md-block">⬅️</span>
                                                    <span className="d-md-none">⬅</span>
                                                </Button>
                                                {this.state.weekShift !== 0 &&
                                                <Button
                                                    color="secondary"
                                                    href="#pablo"
                                                    onClick={e => e.preventDefault()}
                                                    size="sm"
                                                >
                                                    <span className="d-none d-md-block">{this.monthName()}</span>
                                                    <span className="d-md-none">{this.monthName()}</span>
                                                </Button>
                                                }
                                                <Button
                                                    color="secondary"
                                                    href="#pablo"
                                                    onClick={e => this.nextMonth(e, 1)}
                                                    size="sm"
                                                >
                                                    <span className="d-none d-md-block">➡️</span>
                                                    <span className="d-md-none">➡</span>
                                                </Button>
                                            </Nav>
                                        </div>
                                    </Row>
                                    {this.renderReport()}
                                </Card>
                            </Row>
                            }
                        </Card>
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    nextMonth(e, shiftBy) {
        const curStoredValue = parseInt(localStorage.cashier_month_shift)
        localStorage.cashier_month_shift = curStoredValue + shiftBy
        e.preventDefault();
        this.setState({monthShift: this.state.monthShift + shiftBy})
    }

    monthName() {
        let date = new Date();
        date.setMonth(date.getMonth() + this.state.monthShift);
        return dateHelpers.monthYear(date)
    }

    updateCashier(e) {
        this.setState({isLoading: true, cashierData: [], currentCashier: null});
        e.preventDefault();

        const params = this.updateParams()
        reportApiService.updateCashier(params).then(res => {
            this.updateNumbersAndDisplay(res)
        })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    cancelEditing() {
        this.getData()
    }

    updateParams() {
        return {
            cashier_id: this.state.currentCashier.id,
            cash_expense: parseFloat(this.state.cashExpValue) * 100,
            bank_expense: parseFloat(this.state.bankExpValue) * 100,
            card_expense: parseFloat(this.state.cardExpValue) * 100,
            cash_income: parseFloat(this.state.cashIncValue) * 100,
            bank_income: parseFloat(this.state.bankIncValue) * 100,
            card_income: parseFloat(this.state.cardIncValue) * 100,
            date: this.state.currentCashier.date,
            shift: 0
        }
    }

    closeDay(e) {
        this.setState({isLoading: true, cashierData: [], currentCashier: null});
        e.preventDefault();

        const params = this.updateParams()
        reportApiService.closeCashier(params).then(res => {
            this.updateNumbersAndDisplay(res)
        })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    reportName() {
        return resourceStrings.cabinet.cashier
    }

    getData() {
        this.setState({isLoading: true, cashierData: [], currentCashier: null});

        reportApiService.getCashiers({shift: this.state.monthShift, date: new Date()})
            .then(res => {
                this.updateNumbersAndDisplay(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    renderReport() {
        if (this.state.cashierData !== null && this.state.cashierData.length > 0) {
            return <Cashiers
                cashiers={this.state.cashierData}
                closeReport={this.closeReport}
                onCashierDelete={this.onCashierDelete}
                onCashierEdit={this.onCashierEdit}
            />;
        }
    }

    renderIncomesReport() {
        return <CashierIncomesTable style={{width: "100%"}}
                                    transactions={this.state.incomesExpenses.incomes.concat(this.state.incomesExpenses.tickets)}
                                    closeReport={this.closeReport}
                                    addTransaction={this.addIncomingTransaction}
                                    removeTransaction={this.removeIncomingTransaction}
                                    addedTransactions={this.state.addedTransactions}
                                    updatedTimes = {this.state.tablesUpdatedTimes}
                                    currency={this.state.currency}
        />;
    }

    renderExpenseReport() {
        return <CashierIncomesTable style={{width: "100%"}}
                                    transactions={this.state.incomesExpenses.expenses}
                                    closeReport={this.closeReport}
                                    addTransaction={this.addOutcomingTransaction}
                                    removeTransaction={this.removeOutcomingTransaction}
                                    addedTransactions={this.state.addedTransactions}
                                    updatedTimes = {this.state.tablesUpdatedTimes}
                                    currency={this.state.currency}
        />;
    }

    onCashierEdit(cashier) {
        this.setState({currentCashier: null})
        const temp = JSON.parse(JSON.stringify(cashier));

        temp.cash_income = (parseFloat(temp.cash_income) / 100).toFixed(2);
        temp.bank_income = (parseFloat(temp.bank_income) / 100).toFixed(2);
        temp.card_income = (parseFloat(temp.card_income) / 100).toFixed(2);

        temp.cash_expense = (parseFloat(temp.cash_expense) / 100).toFixed(2);
        temp.card_expense = (parseFloat(temp.card_expense) / 100).toFixed(2);
        temp.bank_expense = (parseFloat(temp.bank_expense) / 100).toFixed(2);

        temp.total = (parseFloat(temp.total) / 100).toFixed(2);
        temp.start_total = (parseFloat(temp.start_total) / 100).toFixed(2);

        temp.cash_total = (parseFloat(temp.cash_total) / 100).toFixed(2);
        temp.start_cash_total = (parseFloat(temp.start_cash_total) / 100).toFixed(2);

        cashier.total = temp.total
        cashier.start_total = temp.start_total
        cashier.cash_total = temp.cash_total
        cashier.start_cash_total = temp.start_cash_total

        this.setState({
            currentCashier: cashier,
            cashIncValue: temp.cash_income,
            cardIncValue: temp.card_income,
            bankIncValue: temp.bank_income,
            cashExpValue: temp.cash_expense,
            cardExpValue: temp.card_expense,
            bankExpValue: temp.bank_expense,
            dateValue: temp.date,
            editing: true,
        })
    }

    onCashierDelete(cashier) {
        this.setState({isLoading: true, cashierData: [], currentCashier: null});

        reportApiService.deleteCashier({shift: this.state.monthShift, cashier_id: cashier.id})
            .then(res => {
                this.updateNumbersAndDisplay(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    updateNumbersAndDisplay(res) {
        let current = res.current;
        current.cash_income = (parseFloat(current.cash_income) / 100).toFixed(2);
        current.bank_income = (parseFloat(current.bank_income) / 100).toFixed(2);
        current.card_income = (parseFloat(current.card_income) / 100).toFixed(2);

        current.cash_expense = (parseFloat(current.cash_expense) / 100).toFixed(2);
        current.card_income = (parseFloat(current.card_expense) / 100).toFixed(2);
        current.bank_expense = (parseFloat(current.bank_expense) / 100).toFixed(2);

        current.total = (parseFloat(current.total) / 100).toFixed(2);
        current.start_total = (parseFloat(current.start_total) / 100).toFixed(2);

        current.cash_total = (parseFloat(current.cash_total) / 100).toFixed(2);
        current.start_cash_total = (parseFloat(current.start_cash_total) / 100).toFixed(2);

        let c = res.cashiers || [];
        c.shift()

        this.setState({
            cashierData: c,
            currentCashier: current,
            isLoading: false,
            cashIncValue: current.cash_income,
            cardIncValue: current.card_income,
            bankIncValue: current.bank_income,
            cashExpValue: current.cash_expense,
            cardExpValue: current.card_expense,
            bankExpValue: current.bank_expense,
            dateValue: current.date,
            editing: false,
        });
    }

    dayIncomeTotal() {
        if (this.state.currentCashier == null) return this.state.currency + "0"
        else {
            return this.state.currency + ((
                parseFloat(this.state.currentCashier.cash_income || 0) +
                parseFloat(this.state.currentCashier.card_income || 0) +
                parseFloat(this.state.currentCashier.bank_income || 0)) / 100)
                .toFixed(2)
        }
    }

    dayExpenseTotal() {
        if (this.state.currentCashier == null) return this.state.currency + "0"
        else {
                return this.state.currency +((
                parseFloat(this.state.currentCashier.cash_expense || 0) +
                parseFloat(this.state.currentCashier.card_expense || 0) +
                parseFloat(this.state.currentCashier.bank_expense || 0)) / 100)
                .toFixed(2)
        }
    }

    getIncomesExpenses() {
        this.setState({incomesExpenses: {tickets: [], incomes: [], expenses: []}, tablesUpdatedTimes: this.state.tablesUpdatedTimes + 1})

        reportApiService.incomesExpensesForDay(this.state.dateValue)
            .then(res => {
                this.setState({incomesExpenses: {tickets: res.tickets, incomes: res.incomes, expenses: res.expenses}, tablesUpdatedTimes: this.state.tablesUpdatedTimes + 1})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    addIncomingTransaction(transaction, type) {
        let transactions = this.state.addedTransactions
        if (transactions.includes(JSON.stringify(transaction)) == false) {
            transaction.added = true
            transactions.push(JSON.stringify(transaction))
            this.setState({addedTransactions: transactions})
            let newValue = 0;

            switch (type) {
                case "cash":
                    newValue = (parseFloat(this.state.cashIncValue) + parseFloat(transaction.price)).toFixed(2);
                    this.setState({cashIncValue: newValue})
                    break;
                case "cc":
                    newValue = (parseFloat(this.state.cardIncValue) + parseFloat(transaction.price)).toFixed(2);
                    this.setState({cardIncValue: newValue})
                    break;
                case "bank":
                    newValue = (parseFloat(this.state.bankIncValue) + parseFloat(transaction.price)).toFixed(2);
                    this.setState({bankIncValue: newValue})
                    break;
                default:
                    break;
            }

        }
    }

    removeIncomingTransaction(transaction, type) {
        let transactions = this.state.addedTransactions
        if (transactions.includes(JSON.stringify(transaction))) {
            transaction.added = false
            const filtered = transactions.filter(function(value, index, arr){ return value != JSON.stringify(transaction);})
            this.setState({addedTransactions: filtered})

            let newValue = 0;

            switch (type) {
                case "cash":
                    newValue = (parseFloat(this.state.cashIncValue) - parseFloat(transaction.price)).toFixed(2);
                    this.setState({cashIncValue: newValue})
                    break;
                case "cc":
                    newValue = (parseFloat(this.state.cardIncValue) - parseFloat(transaction.price)).toFixed(2);
                    this.setState({cardIncValue: newValue})
                    break;
                case "bank":
                    newValue = (parseFloat(this.state.bankIncValue) - parseFloat(transaction.price)).toFixed(2);
                    this.setState({bankIncValue: newValue})
                    break;
                default:
                    break;
            }
        }
    }

    addOutcomingTransaction(transaction, type) {
        let transactions = this.state.addedTransactions
        if (transactions.includes(JSON.stringify(transaction)) == false) {
            transaction.added = true
            transactions.push(JSON.stringify(transaction))
            this.setState({addedTransactions: transactions})
            let newValue = 0;

            switch (type) {
                case "cash":
                    newValue = (parseFloat(this.state.cashExpValue) + parseFloat(transaction.price)).toFixed(2);
                    this.setState({cashExpValue: newValue})
                    break;
                case "cc":
                    newValue = (parseFloat(this.state.cardExpValue) + parseFloat(transaction.price)).toFixed(2);
                    this.setState({cardExpValue: newValue})
                    break;
                case "bank":
                    newValue = (parseFloat(this.state.bankExpValue) + parseFloat(transaction.price)).toFixed(2);
                    this.setState({bankExpValue: newValue})
                    break;
                default:
                    break;
            }

        }
    }

    removeOutcomingTransaction(transaction, type) {
        let transactions = this.state.addedTransactions
        if (transactions.includes(JSON.stringify(transaction))) {
            transaction.added = false
            const filtered = transactions.filter(function(value, index, arr){ return value != JSON.stringify(transaction);})
            this.setState({addedTransactions: filtered})

            let newValue = 0;

            switch (type) {
                case "cash":
                    newValue = (parseFloat(this.state.cashExpValue) - parseFloat(transaction.price)).toFixed(2);
                    this.setState({cashExpValue: newValue})
                    break;
                case "cc":
                    newValue = (parseFloat(this.state.cardExpValue) - parseFloat(transaction.price)).toFixed(2);
                    this.setState({cardExpValue: newValue})
                    break;
                case "bank":
                    newValue = (parseFloat(this.state.bankExpValue) - parseFloat(transaction.price)).toFixed(2);
                    this.setState({bankExpValue: newValue})
                    break;
                default:
                    break;
            }
        }
    }
}

CashierView.propTypes = propTypes;